import { useAtom } from 'jotai';
import { useCallback } from 'react';
import {
	addQuestPromptAtom,
	addQuestPromptIfNotAlreadyInAtom,
	addQuestPromptIfNotAlreadyInWithKeyAtom
} from '../devhubSingleQuestStore.atoms';
import { INewQuestPrompt, INewQuestPromptWithUniqueKey } from '../devhubSingleQuestStore.types';

export default function useAddQuestPrompt(): {
	addQuestPrompt: (newPrompt: INewQuestPrompt) => void;
	addQuestPromptWithDelay: (newPrompt: INewQuestPrompt, delay?: number) => void;
	addQuestPromptIfNotAlreadyIn: (newPrompt: INewQuestPrompt, delay?: number) => void;
	addQuestPromptIfNotAlreadyInWithKey: (newPromptWithKey: INewQuestPromptWithUniqueKey, delay?: number) => void;
} {
	const [, addQuestPrompt] = useAtom(addQuestPromptAtom);
	const [, addQuestPromptIfNotAlreadyIn] = useAtom(addQuestPromptIfNotAlreadyInAtom);
	const [, addQuestPromptIfNotAlreadyInWithKey] = useAtom(addQuestPromptIfNotAlreadyInWithKeyAtom);

	const addQuestPromptWithDelay = useCallback(
		(newPrompt: INewQuestPrompt, delay: number | undefined = 1000) => {
			setTimeout(() => {
				addQuestPrompt(newPrompt);
			}, delay);
		},
		[addQuestPrompt]
	);

	return { addQuestPrompt, addQuestPromptWithDelay, addQuestPromptIfNotAlreadyIn, addQuestPromptIfNotAlreadyInWithKey };
}
